{
  "columnResizer": "Størrelsesendring av kolonne",
  "loading": "Laster inn ...",
  "loadingMore": "Laster inn flere ...",
  "resizeColumn": "Endre størrelse på kolonne",
  "sortAscending": "Sorter stigende",
  "sortDescending": "Sorter synkende"
}
